import React from "react";

const decimalSeparator = (() => {
  if (
    typeof window !== "undefined" &&
    window.___APP_CONFIG___ &&
    window.___APP_CONFIG___.DECIMAL_SEPARATOR == "."
  )
    return ".";
  return ",";
})();

const thousandSeparator = (() => {
  if (
    typeof window !== "undefined" &&
    window.___APP_CONFIG___ &&
    window.___APP_CONFIG___.DECIMAL_SEPARATOR == "."
  )
    return ",";
  return ".";
})();

const currency =
  typeof window !== "undefined" && window.___APP_CONFIG___
    ? window.___APP_CONFIG___.DATA_TYPE_DECIMALS.CURRENCY
    : "2";

const price =
  typeof window !== "undefined" && window.___APP_CONFIG___
    ? window.___APP_CONFIG___.DATA_TYPE_DECIMALS.PRICE
    : "4";

const quantity =
  typeof window !== "undefined" && window.___APP_CONFIG___
    ? window.___APP_CONFIG___.DATA_TYPE_DECIMALS.QUANTITY
    : "8";

const percentage =
  typeof window !== "undefined" && window.___APP_CONFIG___
    ? window.___APP_CONFIG___.DATA_TYPE_DECIMALS.PERCENTAGE
    : "2";

const defaultValue =
  typeof window !== "undefined" && window.___APP_CONFIG___
    ? window.___APP_CONFIG___.DATA_TYPE_DECIMALS.DEFAULT
    : "8";

const decimalAmount = {
  quantity: quantity,
  price: price,
  currency: currency,
  percentage: percentage,
  default: defaultValue,
};

export const formattedNumber = (value, dataTypeDecimalName = "default", decimalScale = null, removeZeros) => {
  dataTypeDecimalName = dataTypeDecimalName.toString().toLowerCase().trim();

  // decimalScale < 0 ? (decimalScale = decimalScale * -1) : null;
  decimalAmount[dataTypeDecimalName] === undefined ? (dataTypeDecimalName = "default") : null;

  // removeZeros === undefined && dataTypeDecimalName === "quantity" ? (removeZeros = true) : null;

  //decimalScale = null;
  removeZeros = true;

  let isNegative = false;
  let res = "" + value;
  res = res.trim();
  if (value === null || value === undefined || value === "") return "";

  //If it's negative we'll ignore the - sign until the end.
  if (value < 0) {
    isNegative = true;
    res = value * -1 + "";
  }

  if (
    dataTypeDecimalName === "default" ||
    dataTypeDecimalName === "currency" ||
    dataTypeDecimalName === "quantity"
  ) {
    //Here we change the decimal number amount.
    if (res.includes(".")) {
      if (decimalScale != null) {
        res = parseFloat(res).toFixed(decimalScale);
      } else {
        res = parseFloat(res).toFixed(decimalAmount[dataTypeDecimalName]);
      }
    } else {
      if (decimalScale != null) {
        res = parseFloat(res).toFixed(decimalScale) + "";
      } else {
        res = parseFloat(res).toFixed(decimalAmount[dataTypeDecimalName]) + "";
      }
    }
  }

  const floatRes = parseFloat(res);

  //Here we change the decimal and thousands separators.
  if (res.includes(".")) {
    res = res.split(".");
    if (thousandSeparator === ".") {
      res = parseInt(res[0]).toLocaleString("es-ES") + decimalSeparator + res[1];
    } else {
      res = parseInt(res[0]).toLocaleString("en-US") + decimalSeparator + res[1];
    }
  } else {
    if (thousandSeparator === ".") {
      res = parseInt(res).toLocaleString("es-ES");
    } else {
      res = parseInt(res).toLocaleString("en-US");
    }
  }

  //If value is a 4 digit number we have to manually add a thousand separator
  if (
    (res.includes(decimalSeparator) && res.split(decimalSeparator)[0].length === 4) ||
    (!res.includes(decimalSeparator) && res.length === 4)
  ) {
    res = res.split("")[0] + thousandSeparator + res.substr(1, res.length);
  }

  if (isNaN(floatRes)) return "*****";
  if (isNegative && floatRes != 0 && !removeZeros) res = "-" + res;
  if (isNegative && floatRes != 0 && removeZeros) res = "-" + removeZeroesInDecimals(res);
  if (!isNegative && removeZeros) return removeZeroesInDecimals(res);
  return res;
};

export const FormattedNumber = ({
  value,
  dataTypeDecimalName = "default",
  decimalScale = null,
  removeZeros,
}) => {
  //decimalScale = null;
  removeZeros = true;
  return (
    <span>
      {formattedNumber(value, dataTypeDecimalName, decimalScale, removeZeros) == "NaN"
        ? "-"
        : formattedNumber(value, dataTypeDecimalName, decimalScale, removeZeros)}
    </span>
  );
};

export const removeZeroesInDecimals = (value) => {
  try {
    const regexString =
      decimalSeparator === ","
        ? /^([\d.]+)$|^([\d.]+)\,0*$|^([\d.]+\,[0-9]*?)0*$/
        : /^([\d,]+)$|^([\d,]+)\.0*$|^([\d,]+\.[0-9]*?)0*$/;

    return value.toString().replace(regexString, "$1$2$3");
  } catch (err) {
    return value;
  }
};
